module.exports = __webpack_public_path__ + "img/checked1_img.02660e46.png";